.page {
  padding: 2rem var(--gutter);
  max-width: 56rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
}

.title {
  font-family: var(--font-display);
  font-size: 1.5rem;
  margin: 0;
}

.lede {
  margin: 0;
  color: var(--ink-soft);
  font-family: var(--font-body);
  font-size: var(--text-min-body);
  max-width: 44rem;
}

.category {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.categoryTitle {
  font-family: var(--font-display);
  font-size: 1rem;
  margin: 0;
}

/* A rule is a card because it is a discrete claim about what the policy does —
   not a row in a list of settings. */
.rule {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--radius-sharp);
  padding: 1rem;
}

.ruleLabel {
  margin: 0 0 0.5rem;
  font-family: var(--font-display);
  font-size: 1rem;
}

.logic {
  margin: 0 0 0.75rem;
  color: var(--ink);
  font-family: var(--font-body);
  font-size: var(--text-min-body);
}

.meta {
  margin: 0;
  display: grid;
  gap: 0.5rem;
}

.meta div {
  display: grid;
  grid-template-columns: 11rem 1fr;
  gap: 0.75rem;
  align-items: baseline;
}

.meta dt {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  color: var(--muted);
}

.meta dd {
  margin: 0;
  font-family: var(--font-body);
  font-size: var(--text-min-body);
}

.mono {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
}

/* The pack's own warning, in its own words — not paraphrased. */
.caveat {
  margin: 0;
  color: var(--warn);
  font-family: var(--font-body);
  font-size: var(--text-min-body);
}

.empty,
.error {
  margin: 0;
  font-family: var(--font-body);
  font-size: var(--text-min-body);
}

.error {
  color: var(--stop);
}

@media (max-width: 40rem) {
  .meta div {
    grid-template-columns: 1fr;
    gap: 0.125rem;
  }
}
